import { PermissionModel } from '../../models/permissions/permissions';
import * as RolesModels from '../../models/roles/role';

export class Get {
  static readonly type = '[Role] Get';
  constructor(public RoleId: number) {}
}

export class Set {
  static readonly type = '[Role] Set';
  constructor(public Role: RolesModels.RoleModel) { }
}

export class GetList {
  static readonly type = '[Role] List';
  constructor() { }
}

export class Delete {
  static readonly type = '[Role] Delete';
  constructor(public RoleId: number) { }
}

